export default __webpack_public_path__ + "static/media/kitchen-pack-1.9e3e1d7b.png";